export default __webpack_public_path__ + "static/girl-hero@2x-0d8e0a6519e7609575611fbd622b3776.png";